import { Button } from "@/components/ui/button";
import { Plus, ArrowRightLeft, Download, Repeat, MoreHorizontal } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface QuickActionsProps {
  onAddTransaction: () => void;
  onImport: () => void;
  onTransfer: () => void;
}

export const QuickActions = ({ onAddTransaction, onImport, onTransfer }: QuickActionsProps) => {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="flex items-center gap-2"
    >
      <Button
        onClick={onAddTransaction}
        aria-label="Add Transaction"
        className="gap-2 bg-primary hover:bg-primary/90 text-primary-foreground shadow-md transition-all duration-200 hover:shadow-lg active:scale-95"
      >
        <Plus className="h-4 w-4" aria-hidden="true" />
        <span>Add Transaction</span>
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            aria-label="More actions"
            className="border-border/50 hover:border-primary/50 hover:bg-primary/5 transition-all duration-200"
          >
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem onClick={onTransfer} className="cursor-pointer">
            <ArrowRightLeft className="h-4 w-4 mr-2" />
            Transfer
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onImport} className="cursor-pointer">
            <Download className="h-4 w-4 mr-2" />
            Import statement
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/app/recurring")} className="cursor-pointer">
            <Repeat className="h-4 w-4 mr-2" />
            Recurring
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </motion.div>
  );
};